import React, { useState, useEffect, useRef } from "react";
import { RootState } from "../../../redux/rootReducers";
import { connect } from "react-redux";
import {
  CircularAvatar,
  ContentArea,
  DropDown,
  EmptyListPage,
  ErrorSuccessModal,
  Loader,
  RadioContainer,
} from "../../../components/commons";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import interactionPlugin from "@fullcalendar/interaction";
import {
  calculatePreviousDate,
  formatDate,
  getCurrentFinancialYear,
  getCurrentMonthDates,
  handleDate,
} from "../../../utils/commonFunctions";
import "./approvedCalender.scss";
import subMilliseconds from "date-fns/subMilliseconds";
import {
  AddSchedulingEstimateAction,
  getSchedulingCalendar,
  getSchedulingReEstimateListAction,
  resetCalendarData,
  resetReEstimateDataList,
  resetSchedulingError,
  resetSchedulingMessage,
  resetSchedulingStatusCode,
  resetSchedulingSuccess,
} from "../../../redux/scheduling";
import {
  getAllFinacUsersAction,
  resetAuthError,
  resetSession,
} from "../../../redux/auth";
import { GetAllFinacUserPayloadType } from "../../../commonTypes/authTypes";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Select from "react-select";
import useDebounce from "../../../customHooks/useDebounce";
import EstimateJobUserView from "../../../screens/Scheduling/UserView/EstimateJobUserView";
import { tableEditIcon } from "../../../assets/images";
import { LoginResponseType } from "../../../redux/auth/authTypes";
import { toast, Toaster } from "react-hot-toast";
import ReportsDateSelect from "../../commons/ReportsDateSelect/ReportsDateSelect";
import moment from "moment";
import { RadioTypes } from "../../../commonTypes/universalTypes";
const TAXABILITY_RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "3",
    name: "Approved Request",
  },
  {
    id: "1",
    name: "Pending Request",
  },
  {
    id: "0",
    name: "Show All",
  },
];
type AppProps = {
  data?: any;
  approvedData: any;
  token: any;
  fetching: boolean;
  message: string | null;
  error: string | null;
  statusCode: number | null;
  success: number | null;
  dispatchResetSession: () => void;
  dispatchResetSchedulingError: () => void;
  dispatchResetSchedulingSuccess: () => void;
  dispatchResetSchedulingMessage: () => void;
  dispatchResetSchedulingStatusCode: () => void;
  dispatchgetSchedulingCalendar: (data: any) => void;
  dispatchGetAllFinacUsersAction?: (data: GetAllFinacUserPayloadType) => void;
  finacUser?: any;
  dispatchResetCalendarData: () => void;
  authfetching: boolean;
  authSuccess: number | null;
  authStatusCode: number | null;
  authError: string | null;
  reEstimateDataList: any[];
  dispatchResetReEstimateDataList: () => void;
  dispatchGetReEstimateListAction: (data: any) => void;
  dispatchAddSchedulingEstimateAction: (data: any) => void;
  loginData: LoginResponseType;
  isEdit?: boolean | undefined;
  isRedirected?: string | null;
  redirectData?: any;
};

type CheckBoxType = {
  showAll: boolean;
  approved_entries: boolean;
  pending_entries: boolean;
};

const ApprovedCalander = ({
  approvedData,
  token,
  dispatchgetSchedulingCalendar,
  dispatchGetAllFinacUsersAction,
  finacUser,
  dispatchResetCalendarData,
  fetching,
  authfetching,
  authSuccess,
  authStatusCode,
  authError,
  statusCode,
  success,
  dispatchResetSession,
  dispatchResetSchedulingError,
  dispatchResetSchedulingSuccess,
  dispatchResetSchedulingMessage,
  dispatchResetSchedulingStatusCode,
  error,
  message,
  reEstimateDataList,
  dispatchResetReEstimateDataList,
  dispatchGetReEstimateListAction,
  dispatchAddSchedulingEstimateAction,
  loginData,
  isEdit,
  isRedirected,
  redirectData,
}: AppProps) => {
  const { start, end } = getCurrentMonthDates();
  const [showSchedulingEstimateModal, setShowSchedulingEstimateModal] =
    useState<boolean>(false);
  const [handleLable, setHandleLable] = useState("");
  const [update, setUpdate] = useState({});
  const [showSchedulingEstimateData, setShowSchedulingEstimateData] =
    useState(null);

  const [jobTypeId, setJobTypeId] = useState("");

  const [finalClientValue, setFinalClientValue] = useState<string>("");
  const [clientSelected, setClientSelected] = useState<any>({
    value: null,
    label: "Choose Users..",
  });
  const [text, setText] = useState<string>("");
  const [limit, setLimit] = useState<number>(20);
  const [offset, setOffset] = useState<number>(0);
  const [mode, setMode] = useState("AllWeek");
  const [eventData, setEventData] = useState([]);
  const [currentEsstimate, setCurrentEsstimate] = useState<any>([]);
  const [resources, setResources] = useState<any>([]); //left calander
  const [userList, setUserList] = useState<any>([]);
  const [selectedEvent, setSelectedEvent] = useState<any>(null);
  const calendarRef = useRef<any>(null);
  const [calenderHerderSum, setCalenderHerderSum] = useState<any>([]);
  const [finalEsstimate, setFinalEsstimate] = useState<any>([]);
  const [displayStartDate, setDisplayStartDate] = useState("");
  const [displayEndDate, setDisplayEndDate] = useState("");
  const [startDate, setStartDate] = useState(start);
  const [endDate, setEndDate] = useState(end);
  const [toggle, setToggle] = useState<boolean>(false);
  const [persistName, setPersistName] = useState("");
  const [checkBoxData, setCheckBoxData] = useState<CheckBoxType>({
    showAll: false,
    approved_entries: true,
    pending_entries: false,
  });
  const [filterRadioValue, setFilterRadioValue] = useState(
    TAXABILITY_RADIO_OPTIONS[0]?.id
  );
  const [isShowFilter, setShowFilter] = useState(false);
  let redirectedUserId: string | null = localStorage.getItem("user_id");
  let redirectedName: string | null = localStorage.getItem("name");
  let redirectedStartDate: string | null = localStorage.getItem("start_date");
  let redirectedEndDate: string | null = localStorage.getItem("end_date");
  let redirectedListType: string | null = localStorage.getItem("pendingHours");

  useEffect(() => {
    dispatchResetCalendarData();
    dispatchResetSchedulingError();
    dispatchResetSchedulingSuccess();
    dispatchResetSchedulingMessage();
    dispatchResetSchedulingStatusCode();
  }, []);

  useEffect(() => {
    if (redirectedName?.length) {
      setPersistName(redirectedName);
    }
  }, [redirectedName]);

  useEffect(() => {
    if (isRedirected == "employeeSchedule") {
      setShowFilter(true);
    }
  }, [isRedirected]);

  useEffect(() => {
    const finalUserData = finacUser?.data?.map((user: any) => {
      return {
        value: user?.user_id,
        label: `${user?.first_name ? user?.first_name : ""} ${
          user?.last_name ? user?.last_name : ""
        }`,
        image: user?.profile_pic?.file_url,
      };
    });
    if (offset > 0) {
      setUserList([...userList, ...finalUserData]);
    } else {
      setUserList(finalUserData);
    }
  }, [finacUser]);

  useEffect(() => {
    if (redirectedListType?.length) {
      setFilterRadioValue(TAXABILITY_RADIO_OPTIONS[1]?.id);
      localStorage.removeItem("pendingHours");
    }
  }, [redirectedListType]);

  useEffect(() => {
    if (clientSelected?.label == persistName) {
      setShowFilter(true);
    }
  }, [clientSelected, persistName]);

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset,
        limit,
        user_type: "stco_users",
        status: 1,
        search_term: text,
      };
      dispatchGetAllFinacUsersAction?.(finalUserData);
    }
  }, [offset]);

  const fetchNewData = (search: string) => {
    const finalData = {
      token,
      offset,
      limit,
      user_type: "stco_users",
      status: 1,
      search_term: text,
    };
    dispatchGetAllFinacUsersAction?.(finalData);
  };

  // Custom debounce hook for search data
  useDebounce(
    () => {
      if (text) {
        fetchNewData(text);
      } else {
        const finalData = {
          token,
          offset,
          limit,
          user_type: "stco_users",
          status: 1,
          search_term: text,
        };
        dispatchGetAllFinacUsersAction?.(finalData);
      }
    },
    500,
    [text]
  );

  useEffect(() => {
    if (
      token &&
      redirectedUserId &&
      redirectedName &&
      redirectedStartDate &&
      redirectedEndDate &&
      userList?.length > 0
    ) {
      setClientSelected({ label: redirectedName, value: redirectedUserId });
      handleStartDateChange(redirectedStartDate);
      handleEndDateChange(redirectedEndDate);
      setDisplayStartDate(redirectedStartDate);
      setDisplayEndDate(redirectedEndDate);
      setFinalClientValue(redirectedUserId);
      let finaData = {
        token,
        user_id: redirectedUserId,
        startDate: redirectedStartDate,
        endDate: redirectedEndDate,
        schedule_status: filterRadioValue,
      };

      dispatchgetSchedulingCalendar(finaData);
      localStorage.removeItem("user_id");
      localStorage.removeItem("isRedirected");
      localStorage.removeItem("name");
      localStorage.removeItem("start_date");
      localStorage.removeItem("end_date");
    }
  }, [
    redirectedUserId,
    redirectedName,
    userList,
    redirectedStartDate,
    redirectedEndDate,
    token,
  ]);

  useEffect(() => {
    if (redirectData?.userId && redirectData?.name) {
      setClientSelected({
        label: redirectData?.name,
        value: redirectData?.userId,
      });
    }
  }, [redirectData]);

  useEffect(() => {
    if (redirectData?.userId && redirectData?.name && clientSelected?.value) {
      handleGetScheduleCalenderData();
      setShowFilter(true);
    }
  }, [redirectData, clientSelected]);

  const handleGetScheduleCalenderData = () => {
    if (clientSelected?.value) {
      setShowFilter(true);
      // setFilterRadioValue(TAXABILITY_RADIO_OPTIONS[0]?.id)
      dispatchResetCalendarData();
      setDisplayStartDate(startDate);
      setDisplayEndDate(endDate);
      setFinalClientValue(clientSelected?.value);
      let finaData = {
        token,
        user_id: clientSelected?.value,
        startDate,
        endDate,
        schedule_status: filterRadioValue,
      };

      dispatchgetSchedulingCalendar(finaData);
    }
  };

  useEffect(() => {
    if (resources?.length > 0 && approvedData?.length) {
      let sum = 0;
      for (let i of calenderHerderSum) {
        sum = sum + i?.name;
      }
      let sumTotal = {
        name: "Total Hours Allocated",
        id: 0,
        hours: sum?.toString()?.includes(".") ? +sum?.toFixed(2) : +sum,
      };

      setResources([...resources, sumTotal]);
    } else {
      setResources([]);
    }
  }, [approvedData, calenderHerderSum]);

  ////approved resources

  useEffect(() => {
    if (approvedData?.length > 0) {
      let events = approvedData?.map((ele: any, index: number) => {
        const totalHours = ele?.estimations?.reduce(
          (accumulator: any, currentValue: any) =>
            accumulator + (currentValue?.hours ? +currentValue?.hours : 0),
          0
        );

        return {
          id: ele?.req_id,
          // name: `${ele?.period_ended + `_` + ele?.job_type}`,
          name: `${
            (ele?.job_id != undefined ? ele?.job_id + `_` : "") +
            ele?.job_type +
            `_` +
            formatDate(ele?.period_ended)
          }`,
          hours: totalHours ? +totalHours : 0,
          clientName: `${ele?.client_name} (${ele?.client_code})`,
          data: ele,
          sharedJob: ele?.shared_job ? ele?.shared_job : "",
        };
      });

      setResources([...resources, ...events]);
    }
  }, [approvedData]);

  //single calendar data

  const handleChangeClient = (client: any) => {
    setClientSelected({
      value: client?.value,
      label: client?.label,
    });
    if (clientSelected?.label !== client?.label) {
      setShowFilter(false);
      // setFilterRadioValue(TAXABILITY_RADIO_OPTIONS[0]?.id)
    }
  };

  // approved all data

  useEffect(() => {
    if (approvedData?.length > 0) {
      let events = approvedData
        ?.map((ele: any, index: number) => {
          return ele?.estimations?.map((el: any, i: number) => {
            return {
              resourceId: ele?.req_id,
              campaignId: ele?.req_id,
              name: el?.hours?.toString()?.includes(".")
                ? +el?.hours?.toFixed(2)
                : +el.hours,
              start: new Date(el?.date),
              end: new Date(el?.date),
              allDay: true,
              status: ele?.schedule_status,
            };
          });
        })
        .flat();
      setCurrentEsstimate([...events]);
    } else {
      setCurrentEsstimate([]);
    }
  }, [approvedData]);

  useEffect(() => {
    if (clientSelected?.value && startDate && endDate && isShowFilter) {
      dispatchResetCalendarData();
      setDisplayStartDate(startDate);
      setDisplayEndDate(endDate);
      setFinalClientValue(clientSelected?.value);
      let finaData = {
        token,
        user_id: clientSelected?.value,
        startDate,
        endDate,
        schedule_status: filterRadioValue,
      };

      dispatchgetSchedulingCalendar(finaData);
    }
  }, [filterRadioValue]);

  useEffect(() => {
    let arr: any = [];
    if (currentEsstimate?.length) {
      currentEsstimate?.forEach((el: any) => {
        let date = new Date(el?.start);
        let JsonDate = JSON.stringify(date);
        let final = JsonDate.slice(1, 11);
        arr.push({ date: final, hours: el?.name });
      });

      arr.sort((a: any, b: any) => {
        if (a?.date !== b?.date) {
          return a?.date.localeCompare(b?.date);
        }
        return a?.hours - b?.hours;
      });
      ///sum of header sum
      const dateHoursMap: any = {};
      arr?.forEach((entry: any) => {
        const date = entry?.date;
        const hours = entry?.hours;
        if (date in dateHoursMap) {
          dateHoursMap[date] += hours;
        } else {
          dateHoursMap[date] = hours;
        }
      });

      const result = Object.entries(dateHoursMap).map(([date, hours]) => ({
        resourceId: 0,
        campaignId: 0,
        name: hours,
        start: new Date(date),
        end: new Date(date),
        allDay: true,
      }));

      setCalenderHerderSum(result);

      setFinalEsstimate([...result, ...currentEsstimate]);
    }
  }, [currentEsstimate]);

  let currentFinancial = getCurrentFinancialYear();

  const handleStartDateChange = (date: string) => {
    const value = handleDate(date);
    setStartDate(value);
    setShowFilter(false);
    // setFilterRadioValue(TAXABILITY_RADIO_OPTIONS[0]?.id)
  };
  const handleEndDateChange = (date: string) => {
    const value = handleDate(date);
    setEndDate(value);
    setShowFilter(false);
    // setFilterRadioValue(TAXABILITY_RADIO_OPTIONS[0]?.id)
  };

  function changeApprovedEntriesCheckBox() {
    setCheckBoxData((prv: CheckBoxType) => ({
      ...prv,
      approved_entries: !checkBoxData.approved_entries,
    }));
  }

  function changePendingEntriesCheckBox() {
    setCheckBoxData((prv: CheckBoxType) => ({
      ...prv,
      pending_entries: !checkBoxData.pending_entries,
    }));
  }

  const computeDurations = (mode: any, startDate: string, endDate: string) => {
    switch (mode) {
      case "AllWeek":
        let finalResult: any = {
          slotDuration: { days: 1 },
          slotLabelFormat: [{ month: "long" }, { day: "2-digit" }],
          duration: {
            days:
              startDate && endDate
                ? moment(endDate)?.diff(moment(startDate), "days") + 1
                : 365,
          },
        };
        return finalResult;

      default:
        return {};
    }
  };

  const CampaignResource = ({ resource }: any) => {
    const { name, from, to, type, hours, clientName, data, sharedJob } =
      resource.extendedProps;
    let finalName = name?.slice(0, 18) + "....";
    return (
      <>
        <td
          className="job-id"
          style={{
            color: "#262a44",
            fontSize: "14px",
            fontWeight: "500",
            background:
              name == "Employee Schedule" || name == "Total Hours Allocated"
                ? "rgba(191, 203, 225, 0.6)"
                : "white",
            width: "300px",
            wordWrap: "break-word",
            height: "80px",
            display: "flex",
            flexDirection: "column",
            gap: "3px",
          }}
        >
          {" "}
          {name === "Total Hours Allocated" ? (
            <span style={{ width: "100%" }} className="ml-3">
              {name}
            </span>
          ) : name?.length < 18 ? (
            <span
              className="ml-3"
              style={{ width: "100%", display: "flex", alignItems: "center" }}
            >
              {loginData?.user_id === +finalClientValue &&
                isEdit !== undefined && (
                  <img
                    src={tableEditIcon}
                    alt="edit"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleEstimate(data)}
                    className="mr-2"
                  />
                )}
              <span>
                {name}
                <br></br>
                <span style={{ fontSize: "12px", color: "#6e7491" }}>
                  {clientName?.length > 20
                    ? clientName?.slice(0, 20) + "..."
                    : clientName}
                </span>
              </span>
            </span>
          ) : (
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 250 }}
              overlay={<Tooltip id="button-view-open-item">{name}</Tooltip>}
            >
              <span
                style={{ width: "100%", display: "flex", alignItems: "center" }}
                className="ml-3"
              >
                {loginData?.user_id === +finalClientValue &&
                  isEdit !== undefined && (
                    <img
                      src={tableEditIcon}
                      alt="edit"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleEstimate(data)}
                      className="mr-2"
                    />
                  )}
                <span>
                  {finalName}
                  <br></br>
                  <span style={{ fontSize: "12px", color: "#6e7491" }}>
                    {clientName?.length > 20
                      ? clientName?.slice(0, 20) + "..."
                      : clientName}
                  </span>
                </span>
              </span>
            </OverlayTrigger>
          )}
          {data?.shared_job === true &&
          loginData?.user_id === +finalClientValue ? (
            <span
              style={{
                color: "#6e7491",
                backgroundColor: "#eef1f4",
                borderRadius: "16px",
                padding: "4px 8px",
                marginLeft: `${isEdit !== undefined ? "-71px" : "-111px"}`,
                fontSize: "12px",
              }}
            >
              Shared Job
            </span>
          ) : null}
        </td>
        {name || name === "" ? (
          <td
            className="job-id"
            style={{
              color: hours === "&" ? "transparent" : "#262a44",
              fontSize: "14px",
              fontWeight: "500",
              background:
                name === "Employee Schedule" || name === "Total Hours Allocated"
                  ? "rgba(191, 203, 225, 0.6)"
                  : "white",
              height: "80px",
            }}
          >
            {hours}
          </td>
        ) : (
          ""
        )}
      </>
    );
  };

  const resourceAreaHeaderContent = (arg: any) => {
    return (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "65% 35%",
          justifyContent: "space-between",
          width: "100%",
          marginTop: "21px",
        }}
      >
        <div style={{ textAlign: "initial" }} className="ml-2">
          JOB TYPE & ID
        </div>
        <div>TOTAL HOURS</div>
      </div>
    );
  };

  const { duration, slotDuration, slotLabelFormat } = computeDurations(
    mode,
    displayStartDate,
    displayEndDate
  );
  // const initialDate = new Date(currentFinancial?.split("-")[0] + "-04-01");
  const initialDate = calculatePreviousDate(
    new Date().toISOString().split("T")[0],
    7
  );

  const handleEventContent = (eventInfo: any) => {
    if (
      selectedEvent &&
      selectedEvent?._def?.extendedProps?.campaignId ===
        eventInfo?.event?._def?.extendedProps?.campaignId
    ) {
      // let x=
      return <div></div>;
    } else if (eventInfo?.event?._def?.extendedProps?.name != 0) {
      let checkId = eventInfo?.event?._def?.extendedProps?.campaignId;
      let checkName = eventInfo?.event?._def?.extendedProps?.name;
      let status = eventInfo?.event?._def?.extendedProps?.status;
      return (
        <>
          <div
            style={{
              background:
                status === 3 && checkId != 0
                  ? "#E3EFFF"
                  : checkId != 0 &&
                    eventInfo?.event?._def?.extendedProps?.name < 12
                  ? "#e7f0d4"
                  : checkId != 0 &&
                    eventInfo?.event?._def?.extendedProps?.name > 12
                  ? "#faedd8"
                  : "",
              height: "80px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "15px",
              fontWeight: 500,
              width: "100%",
              margin: "auto",
              // color:
              //   checkId != 0 && eventInfo?.event?._def?.extendedProps?.name < 12
              //     ? "#5a7d0e"
              //     : "#ac6602",
            }}
          >
            {/* {eventInfo?.event?._def?.extendedProps?.name} */}
            <span
              style={{
                width: checkId != 0 ? "100%" : checkId === 0 ? "50%" : "100%",
                height: checkId === 0 && checkName > 12 ? "30px" : "80px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background:
                  checkId === 0 && checkName >= 12
                    ? ""
                    : checkId === 0 && checkName <= 12
                    ? ""
                    : status === 1 && checkId != 0
                    ? "#E3EFFF"
                    : checkName < 12
                    ? "#e7f0d4"
                    : "#faedd8",

                color:
                  checkId === 0 && checkName >= 12
                    ? ""
                    : checkId === 0 && checkName <= 12
                    ? ""
                    : status === 1 && checkId != 0
                    ? "#1B68C8"
                    : checkName >= 12
                    ? "#ac6602"
                    : "#5a7d0e",
              }}
            >
              {" "}
              {checkName}
            </span>
          </div>
        </>
      );
    } else {
      return <div></div>;
    }
  };

  const handleErrorModal = () => {
    if (success === 0 || authSuccess === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => {
              dispatchResetSession();
              dispatchResetSchedulingError();
              dispatchResetSchedulingSuccess();
              dispatchResetSchedulingMessage();
            }}
            statusCode={statusCode}
          />
        );
      } else if (authStatusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!authError}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => {
              dispatchResetSession();
              dispatchResetSchedulingError();
              dispatchResetSchedulingSuccess();
              dispatchResetSchedulingMessage();
            }}
            statusCode={authStatusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetSchedulingError();
              dispatchResetSchedulingSuccess();
              dispatchResetSchedulingMessage();
            }}
          />
        );
      }
    } else if (
      success === 1 &&
      message ===
        "Scheduling request and estimates have been updated successfully!"
    ) {
      dispatchResetSchedulingError();
      dispatchResetSchedulingSuccess();
      dispatchResetSchedulingMessage();
      toast.success(
        "Scheduling request and estimates have been updated successfully!",
        {
          duration: 2000,
        }
      );
      if (clientSelected?.value && endDate && startDate) {
        dispatchResetCalendarData();
        let finaData = {
          token,
          user_id: clientSelected?.value,
          startDate,
          endDate,
          schedule_status: filterRadioValue,
        };

        dispatchgetSchedulingCalendar(finaData);
      }
    }

    return false;
  };

  const checkBottom = () => {
    setOffset((prv: any) => prv + limit);
  };

  const handleToggleEstimateModal = () => {
    // setSendForApproval(false);
    setShowSchedulingEstimateModal(!showSchedulingEstimateModal);
  };

  const handleEstimate = (data: any) => {
    dispatchResetReEstimateDataList();
    setShowSchedulingEstimateData(data);
    setShowSchedulingEstimateModal(!showSchedulingEstimateModal);
    setJobTypeId(data?.job_id);

    // if (data?.schedule_status === 3) {
    let finaData = {
      token,
      id: data?.req_id,
    };
    dispatchGetReEstimateListAction(finaData);
    // }
  };
  const handleSetFilterRadioValue = (value: string) => {
    setFilterRadioValue(value);
  };

  return (
    <>
      <div className="Approvedmanager">
        <h4 className="mr-3 col-md-12 mt-3" style={{ display: "block" }}>
          Employee Schedule
        </h4>
        <div
          className="col-md-12 mt-2"
          style={{ display: "flex", alignItems: "center" }}
        >
          <div>
            <Select
              options={userList}
              value={clientSelected}
              onChange={(e) => handleChangeClient(e)}
              isSearchable={true}
              styles={{
                control: (provided: any, state: any) => ({
                  ...provided,
                  width: "250px",
                  // width: '217px',
                }),
              }}
              isLoading={authfetching}
              onMenuClose={() => {
                setOffset(0);
              }}
              onMenuScrollToBottom={checkBottom}
              onInputChange={(e) => {
                setText(e);
                setOffset(0);
              }}
              // disabled={update}
            />
          </div>

          <div className="ml-2">
            <ReportsDateSelect
              setToggle={setToggle}
              toggle={toggle}
              startDate={startDate ? startDate : ""}
              endDate={endDate ? endDate : ""}
              maxDate={moment(startDate).add(1, "years").toDate()}
              handleStartDateChange={handleStartDateChange}
              handleEndDateChange={handleEndDateChange}
              type={"approvedCalender"}
            />
          </div>

          <button
            disabled={!startDate || !endDate || !clientSelected?.value}
            onClick={() => handleGetScheduleCalenderData()}
            className="btn btn-primary ml-2"
          >
            Apply
          </button>
        </div>
        {isShowFilter && (
          <div className="col-md-12 mt-3">
            <p style={{ fontSize: "14px", fontWeight: 500 }}>
              View Calendar By
            </p>

            <div className="mt-3 mb-4">
              <RadioContainer
                optionsList={TAXABILITY_RADIO_OPTIONS}
                handleSetRadioValue={handleSetFilterRadioValue}
                radioValue={filterRadioValue}
              />
            </div>
          </div>
        )}
        {/* <div
            className="row mt-2 col-md-12"
            style={{ display: "flex", gap: "4%" }}
          >
            <div className="d-flex align-items-start justify-content-start mt-3 mb-2 ">
              <input
                type="checkbox"
                name="show_approved"
                style={{
                  width: "17px",
                  height: "17px",
                  backgroundColor: "red",
                  accentColor: " #dd4433",
                }}
                onChange={changeApprovedEntriesCheckBox}
                className="checkbox"
                checked={checkBoxData?.approved_entries}
              />
              <div>
                <small
                  className="ml-2"
                  style={{ fontSize: "14px", color: "#262a44" }}
                >
                  Approved Request
                </small>
              </div>
            </div>
            <div className="d-flex align-items-start justify-content-start mt-3 mb-2 ">
              <input
                type="checkbox"
                name="approved_entries"
                style={{
                  width: "17px",
                  height: "17px",
                  backgroundColor: "red",
                  accentColor: " #dd4433",
                }}
                onChange={changePendingEntriesCheckBox}
                className="checkbox"
                checked={checkBoxData?.pending_entries}
              />
              <div>
                <small
                  className="ml-2"
                  style={{ fontSize: "14px", color: "#262a44" }}
                >
                  Pending Request
                </small>
              </div>
            </div>
          </div> */}
        {isShowFilter && <hr></hr>}
        {approvedData?.length ? (
          <div>
            <div
              className="ml-3 mt-4"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "15px",
                // justifyContent: "center",
              }}
            >
              <div style={{ fontSize: "17px", fontWeight: 500 }}>
                Schedule of
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  justifyContent: "center",
                }}
              >
                <CircularAvatar
                  name={approvedData[0]?.user_details?.name}
                  image={
                    approvedData[0]?.user_details?.profile_pic?.file_url &&
                    approvedData[0]?.user_details?.profile_pic?.file_url
                  }
                />
                <div>
                  <div>{approvedData[0]?.user_details?.name}</div>

                  <div
                    style={{
                      fontSize: "12px",
                      fontWeight: 500,
                      color: "#6e7491",
                    }}
                  >
                    {" "}
                    {`${
                      approvedData[0]?.user_details?.job_title
                        ? approvedData[0]?.user_details?.job_title
                        : ""
                    }${approvedData[0]?.user_details?.department ? "," : ""} ${
                      approvedData[0]?.user_details?.department
                        ? approvedData[0]?.user_details?.department
                        : ""
                    } `}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        {approvedData?.length ? (
          <FullCalendar
            ref={calendarRef}
            plugins={[interactionPlugin, resourceTimelinePlugin, dayGridPlugin]}
            initialView={"resourceTimeline"}
            initialDate={displayStartDate ? displayStartDate : undefined}
            resourcesInitiallyExpanded={false}
            eventDurationEditable={false}
            resourceOrder="from"
            headerToolbar={{
              left: "",
              center: "title",
              right: "",
            }}
            height={"90vh"}
            resourceAreaHeaderContent={resourceAreaHeaderContent}
            slotDuration={slotDuration}
            slotLabelFormat={slotLabelFormat}
            duration={displayStartDate && displayEndDate && duration}
            resourceLabelContent={CampaignResource}
            resources={resources}
            events={finalEsstimate} //box events
            slotMinWidth={60}
            views={{
              resourceTimelineDay: {
                slowMinWidth: 50,
              },
            }}
            eventClick={(arg: any) => arg.jsEvent.preventDefault()} // Prevent default eventClick behavior
            eventContent={handleEventContent}
          />
        ) : (
          ""
        )}
        {fetching === false && approvedData?.length === 0 ? (
          <div className="mt-5">
            <EmptyListPage title="No Data Found!" imageWidth="30%" />
          </div>
        ) : (
          ""
        )}
      </div>
      {handleErrorModal()}
      <Toaster />
      {fetching && <Loader />}
      {showSchedulingEstimateModal && (
        <EstimateJobUserView
          success={success}
          token={token}
          modal={showSchedulingEstimateModal}
          reEstimateDataList={reEstimateDataList}
          toggleModal={handleToggleEstimateModal}
          jobTypeId={jobTypeId}
          showSchedulingEstimateModal={showSchedulingEstimateModal}
          setShowSchedulingEstimateModal={setShowSchedulingEstimateModal}
          // selectedClient={selectedClient}
          showSchedulingEstimateData={showSchedulingEstimateData}
          // sendForApproval={sendForApproval}
          dispatchAddSchedulingEstimateAction={
            dispatchAddSchedulingEstimateAction
          }
        />
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  approvedData: state.scheduling.calendarData,
  fetching: state.scheduling.fetching,
  message: state.scheduling.message,
  error: state.scheduling.error,
  statusCode: state.scheduling.statusCode,
  success: state.scheduling.success,
  finacUser: state.auth.finacUsersList,
  authfetching: state.auth.fetching,
  authSuccess: state.auth.success,
  authError: state.auth.error,
  authStatusCode: state.auth.statusCode,
  reEstimateDataList: state.scheduling.reEstimateDataList,
  loginData: state.auth.loginData,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetSchedulingError: () => dispatch(resetSchedulingError()),
  dispatchResetSchedulingSuccess: () => dispatch(resetSchedulingSuccess()),
  dispatchResetSchedulingMessage: () => dispatch(resetSchedulingMessage()),
  dispatchResetSchedulingStatusCode: () =>
    dispatch(resetSchedulingStatusCode()),
  dispatchgetSchedulingCalendar: (data: any) =>
    dispatch(getSchedulingCalendar(data)),
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacUsersAction(data)),
  dispatchResetCalendarData: () => dispatch(resetCalendarData()),
  dispatchResetAuthError: () => dispatch(resetAuthError()),
  dispatchResetReEstimateDataList: () => dispatch(resetReEstimateDataList()),
  dispatchGetReEstimateListAction: (data: any) =>
    dispatch(getSchedulingReEstimateListAction(data)),
  dispatchAddSchedulingEstimateAction: (data: any) => {
    dispatch(AddSchedulingEstimateAction(data));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ApprovedCalander);
